import React, { useEffect, useState } from 'react';
import { Badge, Card, Container, ListGroup } from 'react-bootstrap';
import { CursosService } from '../../../../service/cursos.service';
import { Curso } from '../../../../service/types/cursos.types';
import CursoPlayer from './CursoPlayer';

export default function MisCursosList() {
  const [cursos, setCursos] = useState<Curso[]>([]);
  const [cursoActivoId, setCursoActivoId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await CursosService.misCursos();
      setCursos(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (cursoActivoId) {
    return (
      <Container fluid className="p-0">
        <button className="btn btn-link mb-2 p-0" onClick={() => setCursoActivoId(null)}>
          &larr; Volver a mis cursos
        </button>
        <CursoPlayer cursoId={cursoActivoId} onCursoCompletado={load} />
      </Container>
    );
  }

  return (
    <Container fluid className="p-0">
      <Card>
        <Card.Header>Mis cursos</Card.Header>
        <Card.Body>
          <ListGroup>
            {cursos.map((curso) => (
              <ListGroup.Item
                key={curso.id}
                action
                onClick={() => setCursoActivoId(curso.id)}
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong>{curso.titulo}</strong>
                  <div className="text-muted small">
                    Fecha límite: {curso.fechaLimite}
                    {curso.duracion != null && ` · Duración aproximada: ${curso.duracion} h`}
                  </div>
                </div>
                <Badge bg={curso.activo ? 'primary' : 'secondary'}>{curso.activo ? 'Disponible' : 'Inactivo'}</Badge>
              </ListGroup.Item>
            ))}
            {!loading && cursos.length === 0 && (
              <ListGroup.Item className="text-center text-muted">No tiene cursos asignados</ListGroup.Item>
            )}
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}
